import { render, staticRenderFns } from "./ManageBlog.vue?vue&type=template&id=afd5babc&"
import script from "./ManageBlog.vue?vue&type=script&lang=js&"
export * from "./ManageBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports